export const checkRecencyWarnings = (vlieger) => {
  let { recency = {} } = vlieger || vlieger || {};
  if (!recency) return false;
  if (recency.recency) recency = {...recency, ...recency?.recency} // flatten recency if nested

  if (recency.tag == 'niet_vliegend') return false;
  if (recency.tag == 'dbo' || vlieger.tag == 'solist') return false;
  const isNotValid =
    recency.spl === "invalid" ||
    recency.medical ||
    vlieger?.check_med ||
    recency.starts < 15 ||
    recency.vliegduur < 300 ||
    recency.checks < 2 ||
    recency.lieraantekening === "invalid" ||
    recency.sleepaantekening === "invalid" ||
    recency.zelfstartaantekening === "invalid" ||
    recency.tmgaantekening === "invalid" ||
    recency["tmg-a-aantekening"] === "invalid" ||
    recency.bungeeaantekening === "invalid" ||
    recency.caraantekening === "invalid" ||
    recency.bis === "invalid" ||
    recency.fis === "invalid" ||
    recency.fes === "invalid";
  return isNotValid;
};